import { onMounted, onBeforeUnmount } from 'vue'
import type { FormState } from '@/types'
import type { Ref } from 'vue'

export function useKeyboardNav(emits: (event: string) => void, formState: Ref<FormState>) {
  function handleKeyPress(e: KeyboardEvent) {
    if (e.code === 'ArrowLeft' && !formState.value.isFirstField) {
      emits('back')
    }

    if (e.code === 'ArrowRight' && !formState.value.isLastField) {
      emits('next')
    }

    if (e.code === 'Enter') {
      emits('next')
    }
  }

  onMounted(() => {
    window.addEventListener('keydown', handleKeyPress)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('keydown', handleKeyPress)
  })
}
